import React from 'react';
import { formatLocationUtil, formatNumberUtil } from '../../../../../Utils/localStorageUtils';

const MoreDetails = ({ propertyData }) => {

  const { expectedPrice, ownershipType, propertyDescription } = propertyData?.pricingAndOthers?.OwnershipPriceDetails || {}
  const { type_of_flooring } = propertyData?.pricingAndOthers?.PropertyFeatures || {}
  const { status: furnishingStatus } = propertyData?.aboutProperty?.furnishings || {}


  const formattedAddress = formatLocationUtil(propertyData?.locationDetails);


  return (
    <div className="bg-white px-6 py-4 rounded-lg shadow-md">
      {/* Section Title */}
      <h2 className="text-[24px] font-semibold text-[#303030] mb-6">More Details</h2>

      <div className="grid grid-cols-[minmax(150px,200px),1fr] gap-y-4">
        {/* Price Breakup */}
        {expectedPrice && (
          <>
            <div>
              <span className="text-[#303030] font-normal">Price Breakup</span>
            </div>
            <div>
              <span className="text-[#303030] font-semibold text-[16px]">
                ₹ {formatNumberUtil(expectedPrice)}
              </span>
            </div>
          </>
        )}

        {/* Address */}
        {formattedAddress && (
          <>
            <div>
              <span className="text-[#303030] font-normal">Address</span>
            </div>
            <div>
              <span className="text-[#303030] font-semibold text-[16px] capitalize">
                {formattedAddress}
              </span>
            </div>
          </>
        )}

        {/* Furnishing */}
        {furnishingStatus && (
          <>
            <div>
              <span className="text-[#303030] font-normal">Furnishing</span>
            </div>
            <div>
              <span className="text-[#303030] font-semibold text-[16px]">{furnishingStatus}</span>
            </div>
          </>
        )}

        {/* Loan Offered */}
        {false && <>
          <div>
            <span className="text-[#303030] font-normal">Loan Offered</span>
          </div>
          <div>
            <p className="text-[#303030] font-semibold text-[16px]">
              Estimated EMI: ₹20747 <span className="text-gray-500">(info)</span>
            </p>
            <a href="#" className="text-blue-600 hover:underline">Apply for Home Loan</a>
            <div className="flex items-center space-x-2 mt-2">
              <img src="https://via.placeholder.com/50" alt="Indiabulls Logo" className="h-6" />
              <img src="https://via.placeholder.com/50" alt="Bank Logo" className="h-6" />
            </div>
          </div>
        </>}

        {/* Type of Ownership */}
        {ownershipType && (
          <>
            <div>
              <span className="text-[#303030] font-normal">Type of Ownership</span>
            </div>
            <div>
              <span className="text-[#303030] font-semibold text-[16px]">{ownershipType}</span>
            </div>
          </>
        )}


        {/* type_of_flooring */}
        {type_of_flooring && (
          <>
            <div>
              <span className="text-[#303030] font-normal">Flooring</span>
            </div>
            <div>
              <span className="text-[#303030] font-semibold text-[16px]">{type_of_flooring}</span>
            </div>
          </>
        )}
      </div>

      {/* Description */}
      {propertyDescription && (
        <div className="mt-6 flex space-x-3">
          <p className="text-[#303030] font-semibold text-[16px]">Description:</p>
          <p className="text-[#606060] font-normal text-[16px]">{propertyDescription}</p>
        </div>
      )}

      {/* Contact Owner Button */}
      <div className="mt-6">
        <button className="bg-[#2b463c] text-white font-medium px-6 py-2 rounded-full hover:bg-red-700">
          Contact Owner
        </button>
      </div>
    </div>
  );
};

export default MoreDetails;
